import { createReducer } from 'redux-act'

import * as a from '../actions/contentful';

const getDefaultState = () => ({
  content: {},
  curriculums: {},
  activitySet: null,
  isActivitySetLoading: false,
  studentCurriculums: {},
  languages: [],
  hqConfig: {},
  parentConsent: {},
  programTypes: [],
  curriculumSetRemoved: false,
})

export default () =>
  createReducer(
    {
      [a.globalContentLoaded]: (state, data) => {
        return {
          ...state,
          ...data,
        };
      },
      [a.loadActivitySet]: (state, data) => {
        return {
          ...state,
          isActivitySetLoading: true,
          curriculumSetRemoved: false,
          ...data,
        };
      },
      [a.homePageContentLoaded]: (state, data) => {
        return {
          ...state,
          ...data,
        };
      },
      [a.curriculumLoaded]: (state, { code, welcomeModal, nodes }) => {
        return {
          ...state,
          curriculums: {
            ...state.curriculums,
            [code]: {
              code,
              welcomeModal,
              nodes: nodes.curriculums
            },
          },
          studentCurriculums: {
            ...state.studentCurriculums,
            [code]: {
              code,
              welcomeModal,
              nodes: nodes.studentCurriculums
            },
          },
        };
      },
      [a.activitySetLoaded]: (state, data) => {
        const activitySetData = data.ActivitySetQuery;
        if (!!activitySetData?.id) {
          activitySetData.nodes = {};
          for (const row of activitySetData.activities) {
            activitySetData.nodes[row.slug] = row;
          }
        }
        return {
          ...state,
          isActivitySetLoading: false,
          activitySet: activitySetData,
          curriculumSetRemoved: !activitySetData || !activitySetData.id || !activitySetData.hasParent,
        };
      },
    },
    getDefaultState()
  )
